import PendingSvg from "../../components/icons/PendingSvg";

export default function KycPendingViaRain() {
  return (
    <div className="flex flex-col" style={{ gap: "15px" }}>
      <div
        className="rounded-[4px] border border-[#292930] bg-black flex flex-col items-center justify-center"
        style={{ height: "372px", gap: "15px" }}
      >
        <PendingSvg />
      </div>
      <p className="text-[#E6E8ED] text-center font-['Neue Montreal'] text-[16px] font-medium leading-[120%]">
        Your User Verification has been successfully submitted. You can close
        this window and return to the dashboard. Once the User Verification is
        approved, you'll be able to start using your card.
      </p>
    </div>
  );
}
